/*
 * Konex Drone — Módulos CRO del carrito deslizante
 * ================================================
 *
 * IMPORTANTE: este archivo se carga desde snippets/cart-drawer.liquid,
 * FUERA de <cart-drawer>, junto a los demás scripts del tema. Las
 * plantillas <template> también viven ahí.
 *
 * Motivo: Dawn reemplaza el interior del carrito al cambiar cantidades, y
 * un <script> insertado por esa vía nunca llega a ejecutarse. Tampoco vale
 * sections/cart-drawer.liquid, que sólo se usa en las llamadas AJAX.
 *
 * Principios: no se edita más Dawn que esa línea; cada módulo busca su
 * anclaje con alternativas y se rinde en silencio si no lo encuentra; todo
 * es idempotente; un MutationObserver reinyecta tras cada repintado.
 */
(function () {
  'use strict';

  var MAX_CROSS = 2; // productos de venta cruzada visibles a la vez
  var ZONA_DEFECTO = 'peninsula';
  var ZONAS = ['peninsula', 'islas', 'ue'];
  var inyectando = false;
  var temporizador = null;
  var observador = null;
  var iniciado = false;

  /* ------------------------------------------------------------------ */
  /* Utilidades                                                          */
  /* ------------------------------------------------------------------ */

  function carrito() {
    return document.querySelector('cart-drawer');
  }

  function log(error) {
    if (window.console && console.error) console.error('[Konex CRO]', error);
  }

  function plantilla(id) {
    var tpl = document.getElementById(id);
    if (!tpl || !tpl.content || !tpl.content.firstElementChild) return null;
    return tpl.content.firstElementChild;
  }

  function anclaje(raiz, selectores) {
    for (var i = 0; i < selectores.length; i++) {
      var el = raiz.querySelector(selectores[i]);
      if (el) return el;
    }
    return null;
  }

  function variantesEnCarrito(raiz) {
    var ids = {};
    raiz.querySelectorAll('[data-quantity-variant-id]').forEach(function (el) {
      if (el.dataset.quantityVariantId) ids[String(el.dataset.quantityVariantId)] = true;
    });
    raiz.querySelectorAll('cart-remove-button [data-variant-id]').forEach(function (el) {
      if (el.dataset.variantId) ids[String(el.dataset.variantId)] = true;
    });
    return ids;
  }

  function postJSON(url, cuerpo) {
    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      credentials: 'same-origin',
      body: JSON.stringify(cuerpo),
    }).then(function (respuesta) {
      if (!respuesta.ok) return null;
      return respuesta.json();
    });
  }

  function leerCarrito() {
    return fetch('/cart.js', {
      headers: { Accept: 'application/json' },
      credentials: 'same-origin',
      cache: 'no-store',
    }).then(function (respuesta) {
      if (!respuesta.ok) throw new Error('No se pudo leer el carrito');
      return respuesta.json();
    });
  }

  function reemplazarCarrito(datos) {
    var html = datos && datos.sections && datos.sections['cart-drawer'];
    if (!html) return false;

    var actual = carrito();
    if (!actual) return false;

    var doc = new DOMParser().parseFromString(html, 'text/html');
    var nuevo = doc.querySelector('cart-drawer');
    if (!nuevo) return false;

    nuevo.classList.add('active', 'animate');
    nuevo.setAttribute('open', '');
    actual.replaceWith(nuevo);

    if (typeof nuevo.open === 'function') {
      requestAnimationFrame(function () {
        try {
          nuevo.open();
        } catch (error) {
          log(error);
        }
      });
    }
    return true;
  }

  function opcionesSeccion(extra) {
    var base = { sections: 'cart-drawer', sections_url: window.location.pathname };
    for (var clave in extra) {
      if (Object.prototype.hasOwnProperty.call(extra, clave)) base[clave] = extra[clave];
    }
    return base;
  }

  /* ------------------------------------------------------------------ */
  /* Módulo 0 — Zona de envío                                            */
  /* El carrito no conoce la dirección del cliente hasta el checkout, así  */
  /* que la elige él y la recordamos en su navegador.                     */
  /* ------------------------------------------------------------------ */

  function zonaGuardada() {
    var zona = ZONA_DEFECTO;
    try {
      zona = window.localStorage.getItem('knx-zona') || ZONA_DEFECTO;
    } catch (error) {
      zona = ZONA_DEFECTO; // modo incognito o cookies bloqueadas
    }
    return ZONAS.indexOf(zona) === -1 ? ZONA_DEFECTO : zona;
  }

  function guardarZona(zona) {
    try {
      window.localStorage.setItem('knx-zona', zona);
    } catch (error) {
      /* sin persistencia: seguimos igualmente */
    }
  }

  function aplicarZona(raiz) {
    var bloque = (raiz || document).querySelector('.knx-ship');
    if (!bloque) return;

    var zona = zonaGuardada();
    var selector = bloque.querySelector('.knx-ship__select');
    if (selector) selector.value = zona;

    bloque.querySelectorAll('[data-knx-panel]').forEach(function (panel) {
      panel.hidden = panel.dataset.knxPanel !== zona;
    });
  }

  /* ------------------------------------------------------------------ */
  /* Módulo 1 — Venta cruzada                                            */
  /* ------------------------------------------------------------------ */

  function inyectarVentaCruzada(raiz) {
    if (raiz.querySelector('.knx-cross')) return;

    var origen = plantilla('knx-tpl-cross');
    if (!origen) return;

    var destino = anclaje(raiz, ['#CartDrawer-CartItems', '.drawer__contents', 'cart-drawer-items']);
    if (!destino) return;

    var nodo = origen.cloneNode(true);
    var enCarrito = variantesEnCarrito(raiz);
    var visibles = 0;

    nodo.querySelectorAll('[data-knx-variant]').forEach(function (item) {
      if (visibles >= MAX_CROSS || enCarrito[item.dataset.knxVariant]) {
        item.remove();
      } else {
        visibles += 1;
      }
    });

    if (visibles === 0) return;
    destino.appendChild(nodo);
  }

  function mostrarErrorCruzada(boton, mensaje) {
    var seccion = boton.closest('.knx-cross, .knx-bridge');
    var aviso = seccion && seccion.querySelector('.knx-cross__error');
    if (!aviso) return;
    aviso.textContent = mensaje;
    aviso.hidden = false;
  }

  function ocupado(boton, estado) {
    boton.disabled = estado;
    boton.classList.toggle('is-loading', estado);
    if (estado) {
      boton.setAttribute('aria-busy', 'true');
    } else {
      boton.removeAttribute('aria-busy');
    }
  }

  function anadirProducto(boton) {
    var item = boton.closest('[data-knx-variant]');
    var id = item && item.dataset.knxVariant;
    if (!id || boton.disabled) return;

    var cantidad = Number(item.dataset.knxQty || 1);
    if (!cantidad || cantidad < 1) cantidad = 1;

    ocupado(boton, true);

    postJSON('/cart/add.js', opcionesSeccion({ items: [{ id: Number(id), quantity: cantidad }] }))
      .then(function (datos) {
        if (datos && reemplazarCarrito(datos)) return;
        ocupado(boton, false);
        mostrarErrorCruzada(boton, 'No se pudo añadir. Inténtalo de nuevo.');
      })
      .catch(function (error) {
        log(error);
        ocupado(boton, false);
        mostrarErrorCruzada(boton, 'No se pudo añadir. Inténtalo de nuevo.');
      });
  }

  /* ------------------------------------------------------------------ */
  /* Módulo 1b — Puente hacia el envío gratis                            */
  /* ------------------------------------------------------------------ */

  function inyectarPuente(raiz) {
    if (raiz.querySelector('.knx-bridge')) return;

    var origen = plantilla('knx-tpl-bridge');
    if (!origen) return;

    /* Sólo tiene sentido donde hay envío gratis: península. */
    if (zonaGuardada() !== 'peninsula') return;

    var destino = anclaje(raiz, ['.knx-ship']);
    if (!destino) return;

    destino.insertAdjacentElement('afterend', origen.cloneNode(true));
  }

  /* ------------------------------------------------------------------ */
  /* Módulo 2 — Pago seguro                                              */
  /* ------------------------------------------------------------------ */

  function inyectarConfianza(raiz) {
    if (raiz.querySelector('.knx-trust')) return;

    var origen = plantilla('knx-tpl-trust');
    if (!origen) return;

    var destino = anclaje(raiz, ['.cart__ctas', '.cart__checkout-button']);
    if (!destino) return;

    destino.insertAdjacentElement('afterend', origen.cloneNode(true));
  }

  /* ------------------------------------------------------------------ */
  /* Módulo 3 — Protección de envío                                      */
  /* ------------------------------------------------------------------ */

  function inyectarProteccion(raiz) {
    if (raiz.querySelector('.knx-guard')) return;

    var origen = plantilla('knx-tpl-guard');
    if (!origen) return;

    var destino = anclaje(raiz, ['.totals', '.cart-drawer__footer .totals']);
    if (!destino) return;

    var nodo = origen.cloneNode(true);
    var casilla = nodo.querySelector('.knx-guard__input');

    /*
     * El estado se deriva SIEMPRE del carrito real. Nunca se premarca:
     * el art. 60 bis del TRLGDCU prohíbe los pagos adicionales por defecto.
     */
    if (casilla) casilla.checked = Boolean(variantesEnCarrito(raiz)[nodo.dataset.knxVariant]);

    destino.insertAdjacentElement('beforebegin', nodo);
  }

  function alternarProteccion(casilla) {
    var bloque = casilla.closest('.knx-guard');
    var id = bloque && bloque.dataset.knxVariant;
    if (!id) return;

    var quiere = casilla.checked;
    casilla.disabled = true;
    bloque.classList.add('is-loading');

    var accion = quiere
      ? postJSON('/cart/add.js', opcionesSeccion({ items: [{ id: Number(id), quantity: 1 }] }))
      : leerCarrito().then(function (datos) {
          var linea = (datos.items || []).find(function (item) {
            return String(item.variant_id) === String(id);
          });
          if (!linea) return null;
          return postJSON('/cart/change.js', opcionesSeccion({ id: linea.key, quantity: 0 }));
        });

    accion
      .then(function (datos) {
        if (datos && reemplazarCarrito(datos)) return;
        casilla.checked = !quiere;
        casilla.disabled = false;
        bloque.classList.remove('is-loading');
      })
      .catch(function (error) {
        log(error);
        casilla.checked = !quiere;
        casilla.disabled = false;
        bloque.classList.remove('is-loading');
      });
  }

  /* ------------------------------------------------------------------ */
  /* Inyección y re-inyección                                            */
  /* ------------------------------------------------------------------ */

  function inyectarTodo() {
    var raiz = carrito();
    if (!raiz) return;

    inyectando = true;
    try {
      aplicarZona(raiz);
      inyectarPuente(raiz);
      inyectarVentaCruzada(raiz);
      inyectarConfianza(raiz);
      inyectarProteccion(raiz);
    } catch (error) {
      log(error);
    } finally {
      window.setTimeout(function () {
        inyectando = false;
      }, 0);
    }
  }

  function programar() {
    if (inyectando) return;
    window.clearTimeout(temporizador);
    temporizador = window.setTimeout(inyectarTodo, 60);
  }

  function iniciar() {
    if (iniciado) return;
    iniciado = true;

    inyectarTodo();

    if ('MutationObserver' in window) {
      observador = new MutationObserver(programar);
      observador.observe(document.body, { childList: true, subtree: true });
    }

    document.addEventListener('click', function (evento) {
      var destino = evento.target;
      if (!destino || typeof destino.closest !== 'function') return;
      var boton = destino.closest('.knx-cross__add, .knx-bridge__add');
      if (!boton) return;
      evento.preventDefault();
      anadirProducto(boton);
    });

    document.addEventListener('change', function (evento) {
      var destino = evento.target;
      if (!destino || typeof destino.closest !== 'function') return;

      var selectorZona = destino.closest('.knx-ship__select');
      if (selectorZona) {
        guardarZona(selectorZona.value);
        var raiz = carrito();
        aplicarZona(raiz);
        /* El puente sólo aplica en península: lo quitamos o lo reponemos. */
        if (raiz) {
          var puente = raiz.querySelector('.knx-bridge');
          if (puente) puente.remove();
          inyectarPuente(raiz);
        }
        return;
      }

      var casilla = destino.closest('.knx-guard__input');
      if (!casilla) return;
      alternarProteccion(casilla);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', iniciar);
  } else {
    iniciar();
  }
})();
